module.exports = __webpack_public_path__ + "media/assets/images/google-authenticator-8191038be9ce8ceae2df1eb2bea9663d.png";